import React, { useMemo } from 'react';

import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';

import { EmptyBox } from 'shared/base';

import { NO_RESULTS_FOUND_MESSAGE } from '../../constants';
import { TableData } from '../../types';

interface Props {
  cellFormatter?: (cell: any, colIdx: number) => React.ReactNode;
  data: TableData;
  handleFieldSort?: (field: string) => void;
  sortBy?: string;
  sortDir?: 'asc' | 'desc';
}

export const ReportCardTable = ({
  cellFormatter = (cell: any) => cell,
  data: { columns, rows },
  handleFieldSort,
  sortBy,
  sortDir,
}: Props) => {
  // ensure to hide the search_string column
  // @TODO revise if this is best way and/or place for this.
  const { displayColumns, displayRows } = useMemo(() => {
    const searchStringIndex = columns.findIndex((col) =>
      col.name.toLowerCase().includes('search_string'),
    );
    const displayColumns = columns.filter((_, index) => index !== searchStringIndex);
    const displayRows = rows.map((row) => row.filter((_, index) => index !== searchStringIndex));

    return { displayColumns, displayRows };
  }, [columns, rows]);

  return (
    <Box sx={{ height: '100%', overflowY: 'auto', width: '100%' }}>
      <Table sx={{ backgroundColor: 'unset' }}>
        <TableHead sx={{ backgroundColor: 'unset' }}>
          <TableRow>
            {displayColumns.map((column, index) => (
              <TableCell key={`${column}-${index}`} sx={{ paddingX: 1 }}>
                <TableSortLabel
                  active={sortBy === column.name}
                  direction={sortBy === column.name ? sortDir : undefined}
                  onClick={() => handleFieldSort?.(column.name)}
                >
                  {column.label}
                </TableSortLabel>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {displayRows.map((row, colIdx) => {
            const rowKey = `${row.join('-')}-${colIdx}`;

            return (
              <TableRow key={rowKey} hover={true}>
                {row.map((cell, index) => (
                  <TableCell
                    key={`${rowKey}-${cell}-${index}`}
                    sx={{
                      maxWidth: '500px',
                      overflow: 'hidden',
                      paddingX: 1,
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {cellFormatter(cell, colIdx)}
                  </TableCell>
                ))}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
      {rows.length === 0 && <EmptyBox title={NO_RESULTS_FOUND_MESSAGE} />}
    </Box>
  );
};
